import API from "../api/axios.config";

class AsaService {
  
   sendTaskCompletion(data) {
    const step_number = data['step_number'];
    const unique_task_key = data['unique_task_key'];
    const user_id = data['user_id'];

    console.log("sending data", user_id, unique_task_key, step_number)
    return API.post(`/asa`, {user_id, unique_task_key, step_number});
  }

}

export default new AsaService();